import { API_BASE_URL } from "../config/apiBase";

const API_BASE = API_BASE_URL;

function normalizeArray(value) {
  return Array.isArray(value) ? value : [];
}

function normalizeDemoLesson(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    title: String(source.title || "Writeflow Guided Demo"),
    intro: String(source.intro || ""),
    lesson_task: String(source.lesson_task || ""),
    prefill_text: String(source.prefill_text || ""),
    min_word_count: Number(source.min_word_count) > 0 ? Number(source.min_word_count) : 60,
    steps: normalizeArray(source.steps).map((step, index) => ({
      id: String(step?.id || `step_${index + 1}`),
      instruction: String(step?.instruction || ""),
    })),
    mock_feedback: {
      summary: String(source?.mock_feedback?.summary || ""),
      creativity: String(source?.mock_feedback?.creativity || ""),
      clarity: String(source?.mock_feedback?.clarity || ""),
      task_completion: String(source?.mock_feedback?.task_completion || ""),
      coach_feedback: String(source?.mock_feedback?.coach_feedback || ""),
    },
    mock_ner: {
      highlights: normalizeArray(source?.mock_ner?.highlights).map((item) => ({
        label: String(item?.label || "Highlight"),
        text: String(item?.text || ""),
      })),
      note: String(source?.mock_ner?.note || ""),
    },
    completion_cta: String(source.completion_cta || "Continue"),
  };
}

export async function loadDemoLesson() {
  const res = await fetch(`${API_BASE}/api/demo/content`, {
    cache: "no-store",
  });
  if (!res.ok) {
    throw new Error(`Failed loading demo content (${res.status})`);
  }
  const json = await res.json();
  return normalizeDemoLesson(json);
}
